import script from "./TranslatorAssignedJobs.vue?vue&type=script&setup=true&lang=js"
export * from "./TranslatorAssignedJobs.vue?vue&type=script&setup=true&lang=js"

import "./TranslatorAssignedJobs.vue?vue&type=style&index=0&id=66266f5a&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-66266f5a"]])

export default __exports__